/**
 * Following actions are for tracking purposes.
 * GTM is listening for these events and will be able to track them
 * when they are dispatched.
 */
import { createAction } from 'redux-actions'

export const SELECT_AD_INSERTION_INTERACTION = 'SELECT_AD_INSERTION_INTERACTION'
const selectAdInsertionInteraction = createAction(SELECT_AD_INSERTION_INTERACTION)

export const actionCreators = {
  selectAdInsertionInteraction,
}
